import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Плитка со счётчиком: «питомцы 3», «склад 11». Стоит внизу досье.
 *
 * `onOpen` необязателен: там, где переходить некуда, плитка остаётся счётом и
 * рисуется не кнопкой. Кнопка, которая никуда не ведёт, обманывает и палец, и
 * читалку с экрана.
 */
export function CountTile({
  label,
  count,
  onOpen,
}: {
  label: string;
  count: number;
  onOpen?: () => void;
}) {
  const body = (
    <>
      <span className={styles.countTileLabel}>{label}</span>
      <span className={styles.countTileValue}>{count}</span>
    </>
  );

  if (onOpen === undefined) {
    return <div className={clsx(styles.countTile, styles.countTileStatic)}>{body}</div>;
  }

  return (
    <button type="button" className={styles.countTile} onClick={onOpen}>
      {body}
    </button>
  );
}

/** Ряд плиток: переносится, а не сжимает подписи до многоточия. */
export function CountTileRow({ children }: { children: ReactNode }) {
  return <div className={styles.countTileRow}>{children}</div>;
}
